import React from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import "./ButtonField.scss";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function ButtonField(props) {
  const { name, onClick, ...rest } = props;
  const [field, meta] = useField(props);
  const { summaryMode, toggleOptionButton } = rest;
  const { values, setFieldValue } = useFormikContext();

  return (
    <Form.Group
      className={
        toggleOptionButton ? "ButtonField toggleOptionButton" : "ButtonField"
      }
    >
      {!summaryMode ? (
        <>
          {toggleOptionButton ? (
            <button
              type="button"
              className={"gcap-cta"}
              id={name}
              onClick={(e) => onClick(e, values, setFieldValue)}
            >
              <span className="gc-icon-functional-attention-2-col firstOption">
                <span className="path1 firstOption" aria-hidden="true"></span>
                <span className="path2 firstOption" aria-hidden="true"></span>
              </span>
              {field.value === "firstOption"
                ? rest.firstOption
                : rest.secondOption}
            </button>
          ) : (
            <button
              type="button"
              className={"btn btn-secondary"}
              id={name}
              onClick={(e) => onClick(e, values, setFieldValue)}
            >
              {field.value || "Test"}
            </button>
          )}
        </>
      ) : (
        <SummaryItem value={field.value} error={meta.error} />
      )}
    </Form.Group>
  );
}
